export const groupPlans = (plans) => {
    return plans.reduce((c, n) => {
        const benefitName = n.benefit.name;
        const duration = `${n.type} - ${n.length_translated}`;

        if (Object.keys(c).indexOf(benefitName) === -1) {
            c[benefitName] = {selectedDuration: "", durations: {}};
        }

        if (Object.keys(c[benefitName].durations).indexOf(duration) === -1) {
            c[benefitName].durations[duration] = {selectedCoverage: "", coverages: [], "carrier": n.benefit.carrier.name};
        }

        c[benefitName].durations[duration].coverages.push({
            planId: n.id,
            coverageCode: n.coverage,
            coverage: n.coverage_translated,
            adjustedPremium: n.adjusted_premium,
            requireFacility: n.require_facility
        });

        return c;
    }, {})
};

export const isDeltaCareBenefit = (benefitName) => {
    return ['Delta Dental', 'DeltaCare'].indexOf(benefitName) !== -1;
}